/**
 * API Configuration
 *
 * Configuration settings for the Trading API connection
 */

import ENV_CONFIG from './environment';

export const API_CONFIG = {
  baseUrl: ENV_CONFIG.API_BASE_URL,
  timeout: ENV_CONFIG.API_TIMEOUT,
  retryAttempts: ENV_CONFIG.API_RETRY_ATTEMPTS,
  retryDelay: ENV_CONFIG.API_RETRY_DELAY,
  isDevelopment: ENV_CONFIG.IS_DEVELOPMENT,
  endpoints: ENV_CONFIG.API_ENDPOINTS,
} as const;

export default API_CONFIG;


